/**
 * Sticky Auto Hide Header
 *
 * 上にスクロール時は、スクロール量に応じて自然に表示され、
 * 下にスクロール時は、スクロール量に応じて自然にスクロールされ消えていく
 *
 * Ref: https://osvaldas.info/auto-hide-sticky-header
 */
class StickyAutoHideHeader {
  constructor() {
    this.elHeight = 0
    this.elTop = 0
    this.currentY = 0
    this.beforeY = 0
    this.diff = 0
    $(window).on('scroll', this.init)
  }
  init() {
    // ------------------------------------------------------
    // 下記は、pjax遷移するので必ずこのスコープで取得すること
    let element = document.querySelector('#global_header')
    let conpanionElement = document.querySelector('h1.label')
    let btnToTopSp = document.querySelector('.pageTop.sp')
    // ------------------------------------------------------
    this.elHeight = element.offsetHeight
    this.currentY = window.pageYOffset
    this.diff = this.beforeY - this.currentY
    this.elTop = parseInt(window.getComputedStyle(element).getPropertyValue('top'), 10) + this.diff
    let y = null
    if (this.currentY <= 0) { // scrolled to the very top element sticks to the top
      y = 0
    } else if (this.diff > 0) { // scrolled up element slides in
      y = this.elTop > 0 ? 0 : this.elTop
    } else if (this.diff < 0) { // scrolled down
      y = Math.abs(this.elTop) > this.elHeight ? -this.elHeight : this.elTop
    }
    if (y !== null) {
      element.style.top = `${y}px`
      conpanionElement.style.top = `${Math.max(-110, y) + this.elHeight}px`
      btnToTopSp.style.bottom = `${y}px`
    }
    this.beforeY = this.currentY
  }
}

export default StickyAutoHideHeader;
